var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid footer--payment-and-social wrapper"},[_c('div',{staticClass:"row"},[_c('payment',{attrs:{"content":_vm.content}}),_vm._v(" "),_c('socials',{attrs:{"content":_vm.content}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }